<template>
  <div>
    <div id="infoundermenu" :class="classinfoStyle">
      <div v-if="infoTextList.length > 0">
        <i class="close icon" v-on:click="closeInfoShow"></i>
        <ul>
          <li v-for="(item, i) in infoTextList" :key="i">
            {{item}}
          </li>
        </ul> 
      </div>
      <div v-else>
        <i class="close icon" v-on:click="closeInfoShow"></i>
        {{infoText}}</div>
      </div>
    <div v-if="$store.state.isLoading == true" id="isLoading">
      <div>
        <p><font-icon icon="spinner" spin/></p>
        <p>Daten werden geladen. Bitte warten...</p>
      </div>
    </div>
    <div class="admin" v-if="$store.state.user.logged_in == 1">
      <JHMenu />
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import EventBus from "../bus";
import JHMenu from "../components/Menu";

export default {
  name: 'admin',
  data () {
    return {
      firstloaded : 0,
      infoText : "",
      infoTextList : [],
      infoStyle : "",
      infoShow: false,
      timeoutHandle : null
    }
  },
  computed: {
    classinfoStyle (){
      return [this.infoStyle, this.infoShow ? 'show' : 'hide'];
    }
  },
  mounted: function () {
    this.$store.state.heading = "TSV Kunreuth Adminbereich"
    EventBus.$on("logout", () => {
      this.$http.get('/api/logout.pl').then(function (response) {
        this.$store.state.user = response.data.user
        if( this.$store.state.user.logged_in == 0 ){
          this.$router.push({ name: 'login' }) 
        }
      });
    });
    EventBus.$on("checklogin", () => {
      if(this.infoShow){
        window.clearTimeout(this.timeoutHandle);
        this.infoShow = false
      }
      this.$http.get('/api/checklogin.pl').then(function (response) {
        if(this.$store.state.user.logged_in == 1 && response.data.user.logged_in == 0){
          this.$store.state.user = response.data.user
          this.$router.push({ name: 'loginstatus', params: { status: "notloggedin" } })  
        }
        else if(response.data.user.logged_in == 0){
          this.$store.state.user = response.data.user 
          this.$router.push({ name: 'login'})  
        }
        this.$store.state.user = response.data.user 
      });
    });

    EventBus.$on("hideinfo", (style, errorText, time) => {
      if(this.infoShow){
        window.clearTimeout(this.timeoutHandle)
        this.infoShow = false
      }
    }); 

    EventBus.$on("showinfo", (style, errorText, time) => {
      if(style === ''){
        return
      }
      if(this.infoShow){
        window.clearTimeout(this.timeoutHandle);
        this.infoShow = false
      }
      this.infoStyle = style
      if(Array.isArray(errorText)){
        this.infoTextList = errorText
      }
      else{
        this.infoText = errorText
        this.infoTextList = []
      }
      this.infoShow = true
      if(time > 0){
        var self = this;
        var t = time * 1000
        this.timeoutHandle = setTimeout(function(){ 
          self.infoShow = false
        }, t);
      }
    });

    

    EventBus.$emit("checklogin")
  },
  updated: function () {
		this.$nextTick(function () {
			if( this.firstloaded == 0 ){
				this.firstloaded = 1;
			}
			
		})
	},
  methods: {
    closeInfoShow: function (event) {
      this.infoShow = false
    }
  },
  components: {
    JHMenu
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  body{
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    margin: 0;
    padding: 0;
    color: #333;
    /* background-color: white; */
  }
  .admin{
    padding: 55px 15px 15px 55px;
  }
  #infoundermenu{
    max-height: 0;
    -webkit-transition: max-height 0.4s;
    -moz-transition: max-height 0.4s;
    transition: max-height 0.4s;
    margin: 40px auto 0;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 500px;
    z-index: 100;
    font-size: 14px;  
    line-height: 18px;
    padding: 0; 
    overflow: hidden;
    border: 0;
  }
  #infoundermenu ul{
    margin: 0;
    list-style-type: disc;
  }
  #infoundermenu li{
    margin: 0 0 0 30px;
    display: list-item;
  }
  #infoundermenu.show{
    max-height: 1000px;
    -webkit-transition: max-height 1.2s ease-in-out;
    -moz-transition: max-height 1.2s ease-in-out;
    transition: max-height 1.2s ease-in-out;
    opacity: 1;
  }

  #infoundermenu .close{
    position: absolute;
    top: 4px;
    right: 4px;
    height: 20px;
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center; 
    cursor: pointer;
  }
  #infoundermenu.error .close:hover{
    background-color: #eb8f8f;
  } 
  #infoundermenu.info .close:hover{
    background-color: #80c4e6;
  } 
  #infoundermenu.success .close:hover{
    background-color: #85c186;
  }  
   
  #infoundermenu.error div{
    border: 1px solid #eb8f8f;
    border-top: 0;
  }
  #infoundermenu.info div{
    border: 1px solid #31708f;
    border-top: 0;
  }
  #infoundermenu.success div{
    border: 1px solid #1ebc30;
    border-top: 0;
  }
  #infoundermenu div{
    border-top: 0;
    padding: 10px; 
    position: relative;
  }  
  
  #isLoading{
    z-index: 900;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background-color: white; */
    width: 100%;
    height: 100%;
    position: fixed;
    overflow: hidden;
    font-size: 14px;
  }
  #isLoading div{
    text-align: center;
  }
  #isLoading div svg {
    font-size: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Admin.vue